import { useQuery } from "@tanstack/react-query";
import type { JSX, ReactNode } from "react";
import { useORPC } from "../orpc-react.tsx";
import { getCachedAccessToken } from "./Authenticator.tsx";
import { Card } from "./Card.tsx";
import { ProgressIndicator } from "./ProgressIndicator.tsx";

export function AuthenticationStatus(): JSX.Element {
  const orpc = useORPC();
  const auth = useQuery(orpc.iam.whoAmI.queryOptions({ input: {} }));

  let statusText: ReactNode = "Unknown authentication status";
  if (auth.isError) {
    statusText = (
      <>
        <div>Error: {auth.error.message}</div>
        <button onClick={() => auth.refetch()}>Retry</button>
      </>
    );
  } else if (auth.isLoading) {
    statusText = <ProgressIndicator children="Authenticating..." />;
  } else if (auth.isSuccess) {
    const cachedAccessToken = getCachedAccessToken();
    statusText = (
      <>
        <div>
          {auth.isFetching
            ? `Authenticated as ${auth.data.emailAddress}: Refetching...`
            : `Authenticated as ${auth.data.emailAddress}`}
        </div>
        {cachedAccessToken && <div>Token: {cachedAccessToken.slice(0, 10)}...</div>}
      </>
    );
  }

  return <Card title="Authentication">{statusText}</Card>;
}
